import React from 'react';
import { generateKey } from '../../../../infrastructure/helpers/react/commonHelper';

interface Props {
    count: number;
    character: string;
    onParenthesesClick: (bracketNumber: number) => void;
    openParenthesisNumber: number,
    closeParenthesisNumber: number,
    isOpenParenthesis: boolean,
    totalOpenParenthesisCount: number,
    totalCloseParenthesisCount: number,
    hasMatchedBracket:boolean
}

class ParenthesesDisplay extends React.Component<Props> {

    constructor(props: Props) {
        super(props);

        this.prepareBrackets = this.prepareBrackets.bind(this);
    }

    prepareBrackets(): JSX.Element[] {

        let brackets = [] as JSX.Element[];

        let targetNumber = this.props.isOpenParenthesis ? this.props.openParenthesisNumber : this.props.closeParenthesisNumber;

        for (let i = 0; i < this.props.count; i++) {

            let color = 'black';

            let number = i + 1;

            if (number === targetNumber) {

                if (!this.props.hasMatchedBracket) {
                    color = 'red';
                }
                else {
                    color = 'orange';
                }
            }

            brackets.push(<span key={generateKey()} style={{ cursor: 'pointer', paddingLeft: '2px', paddingRight: '2px' }} className={`color-${color}-important`}
                onClick={() => this.props.onParenthesesClick(number)}> {this.props.character}</span>);
        }

        return brackets;
    }

    render(): JSX.Element {


        return (
            <span>{this.prepareBrackets()}</span>
        );
    }
}

export default ParenthesesDisplay;
